import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { CosmosBackdrop } from '../brand/CosmosBackdrop';
import { OnboardingProgressBar } from './OnboardingProgressBar';
import styles from './OnboardingShell.module.css';

interface OnboardingShellProps {
  children: ReactNode;
  /** Optional step indicator (1-6) — hidden on Splash */
  step?: number;
  /** ETA in seconds shown next to the step indicator. Required when `step` is provided. */
  etaSeconds?: number;
  totalSteps?: number;
  className?: string;
  /** Render a back arrow in the top bar that navigates to the given route. */
  backTo?: string;
}

export function OnboardingShell({
  children,
  step,
  etaSeconds,
  totalSteps = 6,
  className,
  backTo,
}: OnboardingShellProps): JSX.Element {
  const nav = useNavigate();
  return (
    <div className={`${styles.root} ${className ?? ''}`}>
      <CosmosBackdrop />
      <div className={styles.content}>
        {backTo && (
          <div className={styles.topBar}>
            <button
              type="button"
              className={styles.backBtn}
              onClick={() => nav(backTo)}
              aria-label="Back"
            >
              <span className={styles.backArrow} aria-hidden="true">←</span>
              Back
            </button>
          </div>
        )}
        {step !== undefined && (
          <OnboardingProgressBar
            step={step}
            etaSeconds={etaSeconds ?? 0}
            totalSteps={totalSteps}
          />
        )}
        {children}
      </div>
    </div>
  );
}
